export enum DaySegment {
    D = 'D',
    A = 'A',
    N = 'N',
    L = 'L',
    X = 'X',
}
